import type { Administrator } from '@quromedical/healthbridge/client';
import { ContactSchema, GeneralSchema } from '@quromedical/models';
import type { SelectOption } from 'components/types';
import { strings } from 'strings';
import { z } from 'zod';

export type IdType = 'medicalAid' | 'idNumber';

export interface Search {
  schemeDetails: SelectOption<Administrator, string>;
  id: string;
  idType: IdType;
}
export const searchIDNumberSchema = z.object({
  id: z.string(),
});

export const searchSchema = z.object({
  idType: z.string(),
  schemeDetails: z.object({}),
  id: z.string().describe(strings.PatientMedicalAidSearchId),
  // TODO add ID number validation, validation not showing on form
});

const baseNextOfKinFormSchema = ContactSchema.merge(GeneralSchema).partial();
export const nextOfKinFormSchema = baseNextOfKinFormSchema
  .omit({ addressCoordinates: true })
  .default({
    birthDate: undefined,
    identifierCode: undefined,
    identifierValue: undefined,
  });
